import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import App from './components/App';
import store from './store';
import './config/ReactotronConfig';

Sentry.init({
	dsn:
		'https://9995093658364b728c112ecba9ea81de@sentry.io/1439410',
});


ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root'),
);
